<template>
  <div>
    <template v-if="embedded">
      <v-card flat class="feature-display-embedded">
        <v-card-text class="pa-0">
          <feature-display-body :feature="value || {}" />
        </v-card-text>
      </v-card>
    </template>

    <v-dialog
      v-else
      v-model="dialog"
      max-width="1100"
      scrollable
      content-class="rounded-xxl"
    >
      <v-card>
        <v-card-text class="pa-0">
          <feature-display-body :feature="feature" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FeatureDisplayBody from "./FeatureDisplayBody.vue";

export default {
  name: "FeatureDisplay",
  components: { FeatureDisplayBody },
  props: {
    value: { type: Object, default: () => ({}) },
    embedded: { type: Boolean, default: false },
  },
  data() {
    return {
      dialog: false,
      feature: {},
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(feature) {
        if (this.embedded) {
          this.feature = structuredClone(feature || {});
        }
      },
    },
  },
  methods: {
    open(feature = null) {
      this.feature = structuredClone(feature || {});
      if (!this.embedded) this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.feature = {};
    },
  },
  mounted() {
    if (!this.embedded) {
      this.$root.$on("feature-display", this.open);
    }
  },
  beforeDestroy() {
    if (!this.embedded) {
      this.$root.$off("feature-display", this.open);
    }
  },
};
</script>
